(() => {
  function addDays(date, days) {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  }

  function toISODate(d) {
    const off = d.getTimezoneOffset();
    const local = new Date(d.getTime() - off * 60 * 1000);
    return local.toISOString().slice(0, 10);
  }

  function getCheckoutButtons() {
    return [
      ...document.querySelectorAll(
        `
        button[name="checkout"],
        button[data-checkout],
        button[class*="checkout"],
        a[href*="/checkout"],
        input[name="checkout"]
        `
      )
    ];
  }

  function disableCheckout() {
    getCheckoutButtons().forEach(btn => {
      btn.setAttribute('disabled', 'disabled');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';
    });
  }

  function enableCheckout() {
    getCheckoutButtons().forEach(btn => {
      btn.removeAttribute('disabled');
      btn.style.pointerEvents = '';
      btn.style.opacity = '';
    });
  }

  function saveToCart(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: { delivery_date: value }
      })
    });
  }

  function lockYear(instance) {
  const yearInput = instance.calendarContainer.querySelector('.cur-year');
  if (yearInput) {
    // Bloqueo duro
    yearInput.setAttribute('readonly', 'readonly');
    yearInput.setAttribute('disabled', 'disabled');
    yearInput.setAttribute('tabindex', '-1');

    // Evita cambios por teclado / scroll / spin buttons
    yearInput.addEventListener('keydown', (e) => e.preventDefault(), { capture: true });
    yearInput.addEventListener('input', (e) => {
      // Revertir al año actual del calendar si intenta cambiar
      yearInput.value = instance.currentYear;
      e.preventDefault();
      e.stopPropagation();
    }, { capture: true });

    yearInput.style.pointerEvents = 'none';
  }

  // Si existieran flechas de año (algunos skins), ocultarlas también
  const yearArrows = instance.calendarContainer.querySelectorAll('.arrowUp, .arrowDown');
  yearArrows.forEach(el => el.style.display = 'none');
}

  function init() {
    const input = document.querySelector('[data-delivery-date]');
    const calendarHost = document.querySelector('[data-delivery-calendar]');
    const errorEl = document.getElementById('CartDeliveryDateError');

    if (!input || !calendarHost) return;

    const minDate = addDays(new Date(), 1); //Ajustar numero, por ejemplo a 2, si quieres que pida con 2 días de anticipación
    const minISO = toISODate(minDate);

    const showError = (show) => {
      if (!errorEl) return;
      errorEl.style.display = show ? 'block' : 'none';
    };

    const isValidISO = (iso) => !!iso && iso >= minISO;

    // Estado inicial
    if (!isValidISO(input.value)) disableCheckout();
    else enableCheckout();

    // Requiere Flatpickr cargado
    if (typeof flatpickr === 'undefined') {
      // Si no cargó por alguna razón, fallback: bloquea checkout
      showError(true);
      disableCheckout();
      return;
    }

      const BLOCKED_DATES = [,
        "2026-02-14",
        "2026-03-25",
        "2026-12-25"
    ];

    // Render inline calendar
    const fp = flatpickr(input, {
      inline: true,
      appendTo: calendarHost,
      dateFormat: "Y-m-d",
      disable: BLOCKED_DATES,
      locale: "es",
      defaultDate: input.value || null,
      minDate: minISO,
      monthSelectorType: "static",

      // ✅ Punto 4: bloquear domingos
      disable: [
        function(date) {
          // 0 = domingo
          return date.getDay() === 0;
        },
        ...BLOCKED_DATES
      ],


  onReady: function(selectedDates, dateStr, instance) {
    lockYear(instance);
  },

  onMonthChange: function(selectedDates, dateStr, instance) {
    // Flatpickr re-renderiza header al cambiar mes → volver a bloquear
    lockYear(instance);
  },

  onYearChange: function(selectedDates, dateStr, instance) {
    // Si por alguna razón cambia, re-bloquear inmediatamente
    lockYear(instance);
  },



      onChange: async function(selectedDates, dateStr) {
        // dateStr ya viene en Y-m-d
        if (!isValidISO(dateStr)) {
          showError(true);
          disableCheckout();
          return;
        }

        showError(false);
        enableCheckout();

        // guardar en carrito (attributes + note)
        try {
          await saveToCart(dateStr);
        } catch (e) {
          showError(true);
          disableCheckout();
        }
      }
    });

    // Si el valor guardado quedó inválido (ej. pasado), lo limpiamos
    if (input.value && !isValidISO(input.value)) {
      input.value = "";
      try { fp.clear(); } catch (_) {}
      showError(true);
      disableCheckout();
    }

    // Extra seguridad por re-render de Gain
    setInterval(() => {
      if (!isValidISO(input.value)) disableCheckout();
    }, 500);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();